import React, { ReactNode } from 'react';
import Paper from '@mui/material/Paper';
import { Divider, Stack } from '@mui/material';
import { PaperProps } from '@mui/material/Paper/Paper';

type Props = PaperProps & {
  header: ReactNode;
  body: ReactNode;
  footer?: ReactNode;
  width?: number | string;
};

export const CustomCard = (props: Props) => {
  const { header, body, footer, width, ...rest } = props;
  return (
    <Stack component={Paper} width={width} {...rest}>
      {header}
      <Divider />
      <Stack height="100%">{body}</Stack>
      {footer && <Divider />}
      {footer}
    </Stack>
  );
};
